import { Tooltip } from 'antd';
import React from 'react';
import { Trans, withTranslation, WithTranslation } from 'react-i18next';

import * as S from 'src/modules/programs/stepComponents/styles';
import stepIcon from 'src/public/img/undraw-to-do-list.svg';

export const CognitiveFlexibilityPracticeStep = withTranslation('cbt')(({ t }: WithTranslation) => {
    const activities = t<string[]>(
        'week-5.cognitive-flexibility-practice.plannedActivities.activities',
        {
            returnObjects: true,
        },
    );

    return (
        <>
            <S.ContentRow>
                <S.ContentColumn md={14}>
                    <S.StepHeading small>
                        {t('week-5.cognitive-flexibility-practice.heading')}
                    </S.StepHeading>
                    <S.StepHeading>
                        {t('week-5.cognitive-flexibility-practice.title')}
                    </S.StepHeading>
                    <S.StepDescription small>
                        <Trans i18nKey="week-5.cognitive-flexibility-practice.description.1">
                            This week, identify one unhelpful/automatic thought, and practice
                            building flexibility around it. You can track it
                            <Tooltip placement="top" title={'Comming soon'}>
                                <S.StyledWord> here</S.StyledWord>.
                            </Tooltip>
                            You can find Alternative Thoughts journal in Toolbox.
                        </Trans>
                    </S.StepDescription>
                    <S.PlannedActivitiesHolder>
                        <S.PlannedActivitiesHeading>
                            {t('week-5.cognitive-flexibility-practice.plannedActivities.heading')}
                        </S.PlannedActivitiesHeading>
                        {activities.map((activity: string) => (
                            <S.PlannedActivity smallPadding key={activity}>
                                <S.ActivityContent>{activity}</S.ActivityContent>
                            </S.PlannedActivity>
                        ))}
                    </S.PlannedActivitiesHolder>
                </S.ContentColumn>
                <S.ContentColumn md={10}>
                    <S.StepIcon large iconUrl={stepIcon} />
                </S.ContentColumn>
            </S.ContentRow>
            <S.ContentRow>
                <S.ContentColumn>
                    <S.StepDescription small>
                        {t('week-5.cognitive-flexibility-practice.description.2')}
                    </S.StepDescription>
                </S.ContentColumn>
            </S.ContentRow>
        </>
    );
});
